const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'en'

export const getStoreCode = (locale?: string): string => {
    const baseStoreCode = process.env.NEXT_PUBLIC_STORE_CODE
    if (baseStoreCode && locale && locale !== defaultLocale) {
        return `${baseStoreCode}_${locale}`
    } else if (baseStoreCode) {
        return baseStoreCode
    } else if (locale && locale !== defaultLocale) {
        return locale
    } else return ''
}
